import { render, staticRenderFns } from "./centerRight4.vue?vue&type=template&id=1a2ef304&scoped=true&"
import script from "./centerRight4.vue?vue&type=script&lang=js&"
export * from "./centerRight4.vue?vue&type=script&lang=js&"
import style0 from "./centerRight4.vue?vue&type=style&index=0&id=1a2ef304&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2ef304",
  null
  
)

export default component.exports